import { GetCompaniesResult, GetRightsResult } from 'src/services/ds.service'
import { ofType, unionize, UnionOf } from 'src/framework'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'

export interface CreateUser {
  type: 'CreateUser'
  email: string
  firstName: string
  lastName: string
  rightIds: number[]
  companyId: string
  creatorToken: string
  [startFetch]: string
}

export interface CreateUserSuccess {
  type: 'CreateUserSuccess'
  [stopFetch]: string
}

export interface CreateUserFailure {
  type: 'CreateUserFailure'
  [stopFetch]: string
}

export interface LoadRights {
  type: 'LoadRights'
  correlationId: string
}

export interface LoadRightsSuccess {
  type: 'LoadRightsSuccess'
  rights: GetRightsResult
}

export interface LoadRightsFailed {
  type: 'LoadRightsFailed'
  correlationId: string
}

export interface LoadCompanies {
  type: 'LoadCompanies'
  correlationId: string
}

export interface LoadCompaniesSuccess {
  type: 'LoadCompaniesSuccess'
  companies: GetCompaniesResult
}

export interface LoadCompaniesFailed {
  type: 'LoadCompaniesFailed'
  correlationId: string
}

export const createUserActions = unionize({
  ...ofType<CreateUser>('CreateUser'),
  ...ofType<CreateUserSuccess>('CreateUserSuccess'),
  ...ofType<CreateUserFailure>('CreateUserFailure'),
  ...ofType<LoadRights>('LoadRights'),
  ...ofType<LoadRightsSuccess>('LoadRightsSuccess'),
  ...ofType<LoadRightsFailed>('LoadRightsFailed'),
  ...ofType<LoadCompanies>('LoadCompanies'),
  ...ofType<LoadCompaniesSuccess>('LoadCompaniesSuccess'),
  ...ofType<LoadCompaniesFailed>('LoadCompaniesFailed')
})

export type CreateUserActions = UnionOf<typeof createUserActions>



// WEBPACK FOOTER //
// ./src/users-components/create-user/create-user.actions.ts